export const PLATFORMS = ["Twitch", "Kick", "ForumTR", "Sosyal Medya", "Web Sitesi"];
export const PACKAGES = ["Popüler Paket", "Master Paket", "MasterX Paket", "Full Paket"];
export const STATUSES = ["BAŞLANDI", "BEKLEMEDE", "İPTAL", "TAMAMLANDI"];

export const STATUS_STYLES = {
  "BAŞLANDI": { bg: "bg-blue-500", text: "text-white", ring: "ring-blue-500/30", dot: "bg-blue-500" },
  "BEKLEMEDE": { bg: "bg-orange-500", text: "text-white", ring: "ring-orange-500/30", dot: "bg-orange-500" },
  "İPTAL": { bg: "bg-red-500", text: "text-white", ring: "ring-red-500/30", dot: "bg-red-500" },
  "TAMAMLANDI": { bg: "bg-green-500", text: "text-white", ring: "ring-green-500/30", dot: "bg-green-500" },
};

export const PLATFORM_ICONS = {
  "Twitch": "twitch",
  "Kick": "zap",
  "ForumTR": "message-square",
  "Sosyal Medya": "share-2",
  "Web Sitesi": "globe",
};

export function formatCurrency(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n);
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function warrantyStatus(iso) {
  if (!iso) return { active: false, daysLeft: 0 };
  try {
    const end = new Date(iso);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    const diff = Math.round((end - today) / (1000 * 60 * 60 * 24));
    return { active: diff >= 0, daysLeft: diff };
  } catch { return { active: false, daysLeft: 0 }; }
}
